module.exports = __webpack_public_path__ + "static/media/se-plc.afc3590a.jpg";